export default [
  {
    "district_id": 648,
    "name": "Abitibi-Est"
  },
  {
    "district_id": 642,
    "name": "Abitibi-Ouest"
  },
  {
    "district_id": 338,
    "name": "Acadie"
  },
  {
    "district_id": 366,
    "name": "Anjou-Louis-Riel"
  },
  {
    "district_id": 520,
    "name": "Argenteuil"
  },
  {
    "district_id": 144,
    "name": "Arthabaska"
  },
  {
    "district_id": 806,
    "name": "Beauce-Nord"
  },
  {
    "district_id": 802,
    "name": "Beauce-Sud"
  },
  {
    "district_id": 218,
    "name": "Beauharnois"
  },
  {
    "district_id": 822,
    "name": "Bellechasse"
  },
  {
    "district_id": 566,
    "name": "Berthier"
  },
  {
    "district_id": 588,
    "name": "Bertrand"
  },
  {
    "district_id": 536,
    "name": "Blainville"
  },
  {
    "district_id": 850,
    "name": "Bonaventure"
  },
  {
    "district_id": 258,
    "name": "Borduas"
  },
  {
    "district_id": 360,
    "name": "Bourassa-Sauvé"
  },
  {
    "district_id": 370,
    "name": "Bourget"
  },
  {
    "district_id": 204,
    "name": "Brome-Missisquoi"
  },
  {
    "district_id": 238,
    "name": "Chambly"
  },
  {
    "district_id": 676,
    "name": "Champlain"
  },
  {
    "district_id": 620,
    "name": "Chapleau"
  },
  {
    "district_id": 748,
    "name": "Charlesbourg"
  },
  {
    "district_id": 760,
    "name": "Charlevoix-Côte-de-Beaupré"
  },
  {
    "district_id": 226,
    "name": "Châteauguay"
  },
  {
    "district_id": 754,
    "name": "Chauveau"
  },
  {
    "district_id": 918,
    "name": "Chicoutimi"
  },
  {
    "district_id": 460,
    "name": "Chomedey"
  },
  {
    "district_id": 814,
    "name": "Chutes-de-la-Chaudière"
  },
  {
    "district_id": 826,
    "name": "Côte-du-Sud"
  },
  {
    "district_id": 320,
    "name": "D'Arcy-McGee"
  },
  {
    "district_id": 508,
    "name": "Deux-Montagnes"
  },
  {
    "district_id": 138,
    "name": "Drummond-Bois-Francs"
  },
  {
    "district_id": 914,
    "name": "Dubuc"
  },
  {
    "district_id": 902,
    "name": "Duplessis"
  },
  {
    "district_id": 466,
    "name": "Fabre"
  },
  {
    "district_id": 854,
    "name": "Gaspé"
  },
  {
    "district_id": 614,
    "name": "Gatineau"
  },
  {
    "district_id": 346,
    "name": "Gouin"
  },
  {
    "district_id": 206,
    "name": "Granby"
  },
  {
    "district_id": 502,
    "name": "Groulx"
  },
  {
    "district_id": 352,
    "name": "Hochelaga-Maisonneuve"
  },
  {
    "district_id": 602,
    "name": "Hull"
  },
  {
    "district_id": 216,
    "name": "Huntingdon"
  },
  {
    "district_id": 210,
    "name": "Iberville"
  },
  {
    "district_id": 858,
    "name": "Îles-de-la-Madeleine"
  },
  {
    "district_id": 310,
    "name": "Jacques-Cartier"
  },
  {
    "district_id": 736,
    "name": "Jean-Lesage"
  },
  {
    "district_id": 702,
    "name": "Jean-Talon"
  },
  {
    "district_id": 364,
    "name": "Jeanne-Mance-Viger"
  },
  {
    "district_id": 126,
    "name": "Johnson"
  },
  {
    "district_id": 570,
    "name": "Joliette"
  },
  {
    "district_id": 922,
    "name": "Jonquière"
  },
  {
    "district_id": 554,
    "name": "L'Assomption"
  },
  {
    "district_id": 720,
    "name": "La Peltrie"
  },
  {
    "district_id": 236,
    "name": "La Pinière"
  },
  {
    "district_id": 232,
    "name": "La Prairie"
  },
  {
    "district_id": 594,
    "name": "Labelle"
  },
  {
    "district_id": 926,
    "name": "Lac-Saint-Jean"
  },
  {
    "district_id": 390,
    "name": "LaFontaine"
  },
  {
    "district_id": 244,
    "name": "Laporte"
  },
  {
    "district_id": 344,
    "name": "Laurier-Dorion"
  },
  {
    "district_id": 454,
    "name": "Laval-des-Rapides"
  },
  {
    "district_id": 670,
    "name": "Laviolette-Saint-Maurice "
  },
  {
    "district_id": 530,
    "name": "Les Plaines"
  },
  {
    "district_id": 818,
    "name": "Lévis"
  },
  {
    "district_id": 810,
    "name": "Lotbinière-Frontenac"
  },
  {
    "district_id": 708,
    "name": "Louis-Hébert"
  },
  {
    "district_id": 304,
    "name": "Marguerite-Bourgeoys"
  },
  {
    "district_id": 246,
    "name": "Marie-Victorin"
  },
  {
    "district_id": 306,
    "name": "Marquette"
  },
  {
    "district_id": 666,
    "name": "Maskinongé"
  },
  {
    "district_id": 548,
    "name": "Masson"
  },
  {
    "district_id": 842,
    "name": "Matane-Matapédia"
  },
  {
    "district_id": 340,
    "name": "Maurice-Richard"
  },
  {
    "district_id": 104,
    "name": "Mégantic"
  },
  {
    "district_id": 350,
    "name": "Mercier"
  },
  {
    "district_id": 482,
    "name": "Mille-Îles"
  },
  {
    "district_id": 514,
    "name": "Mirabel"
  },
  {
    "district_id": 419,
    "name": "Mont-Royal"
  },
  {
    "district_id": 336,
    "name": "Mont-Royal-Outremont "
  },
  {
    "district_id": 252,
    "name": "Montarville"
  },
  {
    "district_id": 742,
    "name": "Montmorency"
  },
  {
    "district_id": 312,
    "name": "Nelligan"
  },
  {
    "district_id": 150,
    "name": "Nicolet-Bécancour"
  },
  {
    "district_id": 324,
    "name": "Notre-Dame-de-Grâce"
  },
  {
    "district_id": 120,
    "name": "Orford"
  },
  {
    "district_id": 626,
    "name": "Papineau"
  },
  {
    "district_id": 380,
    "name": "Pointe-aux-Trembles"
  },
  {
    "district_id": 608,
    "name": "Pontiac"
  },
  {
    "district_id": 714,
    "name": "Portneuf"
  },
  {
    "district_id": 582,
    "name": "Prévost"
  },
  {
    "district_id": 906,
    "name": "René-Lévesque"
  },
  {
    "district_id": 560,
    "name": "Repentigny"
  },
  {
    "district_id": 264,
    "name": "Richelieu"
  },
  {
    "district_id": 132,
    "name": "Richmond"
  },
  {
    "district_id": 838,
    "name": "Rimouski"
  },
  {
    "district_id": 834,
    "name": "Rivière-du-Loup-Témiscouata"
  },
  {
    "district_id": 316,
    "name": "Robert-Baldwin"
  },
  {
    "district_id": 930,
    "name": "Roberval"
  },
  {
    "district_id": 356,
    "name": "Rosemont"
  },
  {
    "district_id": 576,
    "name": "Rousseau"
  },
  {
    "district_id": 636,
    "name": "Rouyn-Noranda-Témiscamingue"
  },
  {
    "district_id": 110,
    "name": "Saint-François"
  },
  {
    "district_id": 326,
    "name": "Saint-Henri-Sainte-Anne"
  },
  {
    "district_id": 260,
    "name": "Saint-Hyacinthe"
  },
  {
    "district_id": 212,
    "name": "Saint-Jean"
  },
  {
    "district_id": 526,
    "name": "Saint-Jérôme"
  },
  {
    "district_id": 318,
    "name": "Saint-Laurent"
  },
  {
    "district_id": 343,
    "name": "Saint-Maurice"
  },
  {
    "district_id": 330,
    "name": "Sainte-Marie-Saint-Jacques"
  },
  {
    "district_id": 230,
    "name": "Sanguinet"
  },
  {
    "district_id": 116,
    "name": "Sherbrooke"
  },
  {
    "district_id": 220,
    "name": "Soulanges"
  },
  {
    "district_id": 470,
    "name": "Ste-Rose"
  },
  {
    "district_id": 250,
    "name": "Taillon"
  },
  {
    "district_id": 730,
    "name": "Taschereau"
  },
  {
    "district_id": 542,
    "name": "Terrebonne"
  },
  {
    "district_id": 660,
    "name": "Trois-Rivières"
  },
  {
    "district_id": 938,
    "name": "Ungava"
  },
  {
    "district_id": 240,
    "name": "Vachon"
  },
  {
    "district_id": 726,
    "name": "Vanier-Les Rivières"
  },
  {
    "district_id": 224,
    "name": "Vaudreuil"
  },
  {
    "district_id": 256,
    "name": "Verchères"
  },
  {
    "district_id": 300,
    "name": "Verdun"
  },
  {
    "district_id": 358,
    "name": "Viau"
  },
  {
    "district_id": 476,
    "name": "Vimont"
  },
  {
    "district_id": 332,
    "name": "Westmount-Saint-Louis"
  },
]
